import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RedirectUriGuard } from '@app/guards/redirect-uri.guard';
import { CanAccessRegisterFormGuard } from '@app/pages/register-page/container/register-page-container/can-access-register-form.guard';
import { RegisterPageEmailSuccessComponent } from './components/register-page-email-success/register-page-email-success.component';
import { RegisterPagePrimaryPhoneSuccessComponent } from './components/register-page-primary-phone-success/register-page-primary-phone-success.component';
import { RegisterPageContainerComponent } from './container/register-page-container/register-page-container.component';

const routes: Routes = [
  {
    path: '',
    component: RegisterPageContainerComponent,
    canActivate: [CanAccessRegisterFormGuard, RedirectUriGuard],
  },
  {
    path: 'register/email/success',
    component: RegisterPageEmailSuccessComponent,
  },
  {
    path: 'register/primary-phone/success',
    component: RegisterPagePrimaryPhoneSuccessComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RegisterPageRoutingModule {}
